
import React from 'react';
import "./headermodal.scss";
import Icon from '../../assets/svg/add-plus.svg';

const HeaderModal = ({ title, subtitle}) => {
    
    return (
        <div className="gb-header-modal">
            <div className="gb-header-modal-cont">
                <img src={Icon} width="22"/>
                <div className="gb-header-modal-title">{title}</div>
            </div>
            <div className="gb-header-modal-subtitle">{subtitle}</div>
        </div>
    )
}

export default HeaderModal;